<template>
  <v-container
  align-center
  fluid
  >
    <v-row justify="space-around">
      <v-col cols=8>
        <h1>Contact</h1>
        <p>
          If you have any questions regarding the practices of this site, or your dealings with this site, please 
          <a href="mailto:contact@reddit.watch">contact us</a>.
        </p>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
  }),
};
</script>
